import PropTypes from 'prop-types'
import moment from 'moment'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { displayWithCurrency } from '../../../../utility/currency'

import classes from './MembershipPlanCard.module.scss'

const MembershipPlanCard = ({ membership, familyUsers }) => {
  const { t } = useTranslation()
  const coveredNames = familyUsers.filter(u => membership.coveredUserIds.includes(u.id)).map(u => u.first_name)
  const periodEnd = moment(membership.currentPeriodEnd).format('ll')

  return (
    <section className={classes.membershipPlanCard}>
      <div className='d-flex align-items-start justify-content-between'>
        <div>
          <p className={classes.label}>{t('dashboard.student.accountTab.membership.currentPlan')}</p>
          <h4 className={classes.planName}>
            {t('dashboard.student.accountTab.membership.planName', { tier: t(`programs.registration.membershipPlan.tiers.${membership.tier}`) })}
          </h4>
          <p className={classes.coverage}>
            {t('dashboard.student.accountTab.membership.coverage', { count: coveredNames.length, names: coveredNames.join(', ') })}
          </p>
        </div>
        <span className={classes.status}>{t(`dashboard.student.accountTab.membership.status.${membership.status}`)}</span>
      </div>

      <div className={classNames(classes.footer, 'd-flex align-items-center justify-content-between')}>
        <span className={classes.periodEnd}>
          {t(
            membership.autoRenew ? 'dashboard.student.accountTab.membership.renews' : 'dashboard.student.accountTab.membership.ends',
            { date: periodEnd }
          )}
        </span>
        <span className={classes.price}>
          {t('programs.registration.membershipPlan.perYear', { price: displayWithCurrency(membership.amount, membership.currency) })}
        </span>
      </div>
    </section>
  )
}

MembershipPlanCard.propTypes = {
  membership: PropTypes.shape({
    status: PropTypes.string,
    tier: PropTypes.string,
    amount: PropTypes.number,
    currency: PropTypes.object,
    coveredUserIds: PropTypes.arrayOf(PropTypes.number),
    autoRenew: PropTypes.bool,
    currentPeriodEnd: PropTypes.string,
  }).isRequired,
  familyUsers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    first_name: PropTypes.string,
  })).isRequired,
}

export default MembershipPlanCard
